import Vue from 'vue'
import 'regenerator-runtime'

import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Apollo from './vue-apollo'
import { TopHeader } from 'tvu-common-ui'
import '@/assets/style.css'
import 'nprogress/nprogress.css'
import axiosInstance from './api/axiosInstance'
import payment from './components/AddPayments/index.js'
import Draggable from './directive/drag.js'
import i18n from './lang/index'
import './theme/dark.css'
import './theme/light.css'
Vue.use(Draggable)
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

Vue.use(payment)

Vue.config.productionTip = false
Vue.prototype.$axios = axiosInstance
Vue.use(TopHeader)
Vue.prototype.$TVU = {
  http: axiosInstance
}
new Vue({
  router,
  store,
  i18n,
  apolloProvider: Apollo,
  render: (h) => h(App)
}).$mount('#app')
